<template>
  <!-- style="box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12)" -->
  <div
    class="bg-white w-32px h-32px rounded-4px !flex items-center justify-center cursor-pointer"
    @click="layoutStore.toggleExpand"
  >
    <i class="el-icon-full-screen text-16px"></i>
  </div>
</template>

<script setup lang="ts">
import useLayoutStore from '@/stores/layout';
const layoutStore = useLayoutStore();

// 检测放大的时候，监听按esc 退出全屏

watch(
  () => layoutStore.isExpand,
  (newValue, oldValue) => {
    if (newValue) {
      modal.msgWarning('按ESC退出全屏');
      document.addEventListener('keydown', function (event) {
        if (event.keyCode == 27) {
          layoutStore.shrinkMain();
        }
      });
    }
  }
);
</script>

<style scoped></style>
